import { render, staticRenderFns } from "./GetExternalOdds.vue?vue&type=template&id=6759bb08&scoped=true&"
import script from "./GetExternalOdds.vue?vue&type=script&lang=js&"
export * from "./GetExternalOdds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6759bb08",
  null
  
)

export default component.exports